const toFiniteNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

export const parseOptionalPositiveNumber = (value) => {
  const raw = String(value ?? '')
    .trim()
    .replace(',', '.');
  if (!raw) return undefined;

  const number = Number(raw);
  return Number.isFinite(number) && number > 0 ? number : null;
};

export const formatMillimeters = (value) => {
  const number = toFiniteNumber(value);
  if (number === null) return null;

  const rounded = Math.round(number * 10) / 10;
  return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
};

export const getDetectedFormatDimensions = (details = {}) => ({
  widthMm: toFiniteNumber(details.detectedWidthMm ?? details.widthMm),
  heightMm: toFiniteNumber(details.detectedHeightMm ?? details.heightMm),
});

export const formatDimensionsLabel = ({ widthMm, heightMm } = {}) => {
  const width = formatMillimeters(widthMm);
  const height = formatMillimeters(heightMm);

  if (!width || !height) return 'dimensioni non disponibili';
  return `${width} x ${height} mm`;
};

export const formatClosestFormatOption = (format = {}) => {
  const name = format.name || 'Formato senza nome';
  const dimensions = formatDimensionsLabel(format);
  const distance = formatMillimeters(format.distanceMm);

  if (!distance) return `${name} - ${dimensions}`;
  return `${name} - ${dimensions} (diff. ${distance} mm)`;
};

export const buildClosestFormatOptions = (closestFormats = []) =>
  closestFormats.reduce((options, format, index) => {
    if (!format?.formatId) return options;

    return {
      ...options,
      [String(index)]: formatClosestFormatOption(format),
    };
  }, {});

export const getClosestFormatByIndex = (closestFormats = [], selectedIndex) => {
  const index = Number(selectedIndex);
  if (!Number.isInteger(index)) return null;

  return closestFormats[index] || null;
};

export const getFormatPointerField = (formatIsDefault) =>
  formatIsDefault === false
    ? 'editor_project_formats_pointer'
    : 'editor_project_formats_default_pointer';

export const addFormatPointer = (
  fields,
  { formatId, formatIsDefault, defaultFormatId } = {}
) => {
  if (!formatId) return fields;

  fields[getFormatPointerField(formatIsDefault)] = { link: formatId };
  if (formatIsDefault === false && defaultFormatId) {
    fields.editor_project_formats_default_pointer = { link: defaultFormatId };
  }
  return fields;
};
